// Banner at the top of the main area asking to allow system notifications in this browser. Shown on
// each device until it's answered or closed; Settings → Notifications has the same switch.
import { Bell, X } from '@/components/ui/icons';
import { toast } from '@/components/ui/overlays';
import { desktop } from '@/lib/desktop';
import { requestNotifyPermission, sendTestNotification, useNotifyPermission } from '@/lib/notify';
import { useUi } from '@/lib/ui';

/** Ask the browser; on yes, send a sample so people see what they'll get. */
export async function turnOnNotifications() {
  const result = await requestNotifyPermission();
  if (result === 'granted') sendTestNotification();
  else if (result === 'denied') toast("Notifications are blocked. You can allow them in your browser's site settings for Atrium.");
  return result;
}

export function NotificationPrompt() {
  const permission = useNotifyPermission();
  const dismissed = useUi((s) => s.notifyPromptDismissed);
  if (desktop() || permission !== 'default' || dismissed) return null;
  return (
    <div className="notify-prompt" role="region" aria-label="Notifications">
      <span className="notify-prompt-icon">
        <Bell size={15} />
      </span>
      <span className="grow">Get a notification on your computer when someone mentions you, assigns you a task or messages you.</span>
      <button className="btn sm primary" onClick={() => void turnOnNotifications()}>
        Turn on notifications
      </button>
      <button className="icon-btn xs" onClick={() => useUi.setState({ notifyPromptDismissed: true })} aria-label="Dismiss">
        <X size={14} />
      </button>
    </div>
  );
}
